import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const phoneExtDepartmentService = {
    getAll,
    store,
    show,
    update,
    updateStatus,
    updateSequence,
};

const MODULE = {
    PHONE_EXT_DEPARTMENT: 'phone-ext-departments',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll (filter) {
    const request = {
        params: {
            phone_ext_group_uuid: filter?.phoneExtGroupUuid,
            is_active: filter?.isActive,
        },
    };

    return apiHelper(API_URL).get(`/${MODULE.PHONE_EXT_DEPARTMENT}`, request);
}

export function store (data) {
    const request = {
        phone_ext_group_uuid: data.phoneExtGroupUuid,
        department_uuid: data.departmentUuid,
        sequence: data.sequence,
    };

    return apiHelper(API_URL).post(`/${MODULE.PHONE_EXT_DEPARTMENT}`, request);
}

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.PHONE_EXT_DEPARTMENT}/${uuid}`);
}

export function update (data) {
    const request = {
        phone_ext_group_uuid: data.phoneExtGroupUuid,
        department_uuid: data.departmentUuid,
        sequence: data.sequence,
    };

    return apiHelper(API_URL).put(`/${MODULE.PHONE_EXT_DEPARTMENT}/${data.uuid}`, request);
}

export function updateStatus (data) {
    const request = {
        is_active: data.isActive,
    };

    return apiHelper(API_URL).patch(`/${MODULE.PHONE_EXT_DEPARTMENT}/${data.uuid}`, request);
}

export function updateSequence (data) {
    const request = {
        phone_ext_group_uuid: data.phoneExtGroupUuid,
        departments: (data.departments ?? []).map(item => ({
            uuid: item.uuid,
            sequence: item.sequence,
        })),
    };

    return apiHelper(API_URL).patch(`/${MODULE.PHONE_EXT_DEPARTMENT}/sequences`, request);
}